/**
 * Class for managing feature flags
 */
class FeatureFlags {
  /**
   * @description Create a map of flags
   * @param {Object.<string, boolean>} flags
   */
  constructor(flags) {
    /**
     * @type {Map<string, boolean>}
     */
    this.flags = new Map(Object.entries(flags));
  }
  isActive(flag) {
    return !!this.flags && this.flags.get(flag);
  }
  setFlag(flag) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!this.flags) return;
    this.flags.set(flag, value);
  }

  /**
   * @type {Object<string, string>} names
   */
  get names() {
    if (!this.flags) return;
    return [...this.flags.keys()].reduce((prev, val) => ({
      ...prev,
      [val]: val
    }), {});
  }
}

export { FeatureFlags };
